// ABOUTME: Labelled "or" separator between auth method sections (OIDC / password / code).
// ABOUTME: Single source for the divider so every auth screen renders it identically.

/** Labelled "or" separator between auth method sections. */
export const AuthDivider = ({ label }: { label: string }) => (
  <div className="flex items-center gap-3 text-xs text-gray-400">
    <span className="h-px flex-1 bg-border" />
    {label}
    <span className="h-px flex-1 bg-border" />
  </div>
)
